import { Pipe, PipeTransform } from '@angular/core';
import { formatDuration, intervalToDuration } from 'date-fns';

@Pipe({
  name: 'dateInterval',
  standalone: false,
})
export class DateIntervalPipe implements PipeTransform {
  transform(start: string | Date, end: string | Date): string {
    const duration = intervalToDuration({
      start: new Date(start),
      end: new Date(end),
    });
    if (duration.years) return $localize`${duration.years} years`;
    if (duration.months) return $localize`${duration.months} months`;
    if (duration.weeks) return $localize`${duration.weeks} weeks`;
    if (duration.days) return $localize`${duration.days} days`;
    if (duration.hours) return $localize`${duration.hours} hours`;
    if (duration.minutes) return $localize`${duration.minutes} minutes`;
    if (duration.seconds) return $localize`${duration.seconds} seconds`;
    return formatDuration(duration);
  }
}
